import React from "react";
import "../css/Contact.css";

const Contact = () => {
  return (
    <div className="contact5">

      {/* ======================================================
          HERO — Soft Leaf Backdrop
      ======================================================= */}
      <section className="ct-hero">
        <div className="ct-leaf-bg"></div>

        <h1>Contact Us</h1>
        <p>
          Reach out anytime — we're here to guide your natural fitness journey.
        </p>
      </section>



      {/* ======================================================
          CONTACT INFO BLOCKS
      ======================================================= */}
      <section className="ct-info-wrap">
        <div className="ct-info-card">
          <h3>Address</h3>
          <p>124 Greenwood Ave, Portland, OR</p>
        </div>

        <div className="ct-info-card">
          <h3>Phone</h3>
          <p>+1 800 244 9023</p>
        </div>

        <div className="ct-info-card">
          <h3>Email</h3>
          <p>support@earthfit.com</p>
        </div>

        <div className="ct-info-card">
          <h3>Working Hours</h3>
          <p>Monday – Sunday</p>
          <p>6:00 AM – 10:00 PM</p>
        </div>

        <div className="ct-socials">
          <a href="#"><i className="ri-instagram-line"></i></a>
          <a href="#"><i className="ri-facebook-fill"></i></a>
          <a href="#"><i className="ri-youtube-fill"></i></a>
        </div>
      </section>



      {/* ======================================================
          MAP SECTION — Organic Shape
      ======================================================= */}
      <section className="ct-map-section">
        <h2>Find Us</h2>

        <div className="ct-map-box">
          <iframe
            title="earthfit-map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2796.9480438949033!2d-122.6765!3d45.5231!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5495a0b2eac!2sPortland%20OR!5e0!3m2!1sen!2sus!4v1234567890"
            loading="lazy"
            allowFullScreen=""
          ></iframe>
        </div>
      </section>



      {/* ======================================================
          END PANEL
      ======================================================= */}
      <section className="ct-end">
        <h2>We're Here to Help</h2>
        <p>Reach out anytime — we’ll respond with clarity and care.</p>
      </section>

    </div>
  );
};

export default Contact;
